/**
 * Shared PDF styles used across all document templates.
 * Import and spread into per-document StyleSheet.create() calls,
 * or use directly for common elements.
 */
import { StyleSheet } from '@react-pdf/renderer'

import { mm } from '@/frontend/features/printing/pdf-utils'

export const baseStyles = StyleSheet.create({
  page: {
    padding: mm(25),
    fontFamily: 'Helvetica',
    fontSize: 10,
    lineHeight: 1.6,
  },
  text: { fontSize: 10, marginBottom: mm(1) },
  bold: { fontFamily: 'Helvetica-Bold' },
  italic: { fontFamily: 'Helvetica-Oblique' },
  sectionGap: { marginTop: mm(4) },
  heading: { fontFamily: 'Helvetica-Bold', fontSize: 10, marginTop: mm(4) },
  listItem: { fontSize: 10, marginBottom: mm(2), paddingLeft: mm(5) },
  title: {
    fontSize: 12,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
    textDecoration: 'underline',
    marginBottom: mm(8),
  },
  divider: { borderBottomWidth: 0.5, borderBottomColor: '#ccc', marginVertical: mm(6) },
})
